import {settingService} from "../services/setting.service";
import {settingConstants} from "../constants/setting.constants";
import {toastr} from 'react-redux-toastr'
import i18next from "i18next";

const getConfigList = () => {
    return dispatch => {
        settingService.getConfigList()
            .then(
                (configModel) => {
                    dispatch({type: settingConstants.CONFIG_SUCCESS, configModel })
                },
                (error) => {
                    dispatch({type: settingConstants.CONFIG_FAILURE, error})
                }
            )
    }
};

const editConfig = (editModel) => {
    return dispatch => {
        settingService.editConfig(editModel)
            .then(
                () => {
                    dispatch(getConfigList());
                    toastr.info(i18next.t('settings'), i18next.t('msg.edit-settings', { key: editModel.key }));
                },
                (error) => {
                    const errorResponse = error.response.data['errorMessages'];
                    const key = Object.keys(errorResponse);

                    key.forEach(item => {
                        toastr.error(i18next.t('settings'), i18next.t('validation.' + errorResponse[item][0]))
                    });
                }
            );
    }
};

export const settingAction = {
    getConfigList,
    editConfig
};
